export default __webpack_public_path__ + "static/media/vehicle.fe4c0570.svg";